const getArnCategoriesColumnGroups = () => [
  {
    id: 'category',
    name: 'Category',
    hideInSelect: true,
  },
]

export { getArnCategoriesColumnGroups }
